"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTableView = void 0;
var React = require("react");
var DataTableView = function (props) { return (React.createElement("div", { onClick: props.onClick, className: "pl1 pl3-ns pv2" },
    React.createElement("div", { className: "w-100" },
        React.createElement("div", { className: "cf" },
            React.createElement("div", { className: "fl ".concat(props.actionButton ? 'w-70-ns' : 'w-100-ns', " w-100") }, props.fieldsByColumn.map(function (column, index) { return (React.createElement("div", { key: index, className: "fl ".concat(column.width, " pa1") },
                React.createElement("span", { className: "fl fw3 i" }, column.title),
                React.createElement("span", { className: "fl pl2 fw3" }, column.value))); })),
            props.actionButton ?
                React.createElement("div", { className: "fl w-30-ns w-100" }, props.actionButton()) : undefined)))); };
exports.DataTableView = DataTableView;
//# sourceMappingURL=DataTableView.js.map